
import { Component, Vue } from 'vue-property-decorator'
import LocationMap from '@/components/maps/LocationMap.vue'
import { MarkerPosition } from '@/types//Maps'

@Component({
  components: {
    LocationMap
  }
})
export default class Fillgrid extends Vue {
  type = 0
  src: any

  mediaViewerTypes = {
    IMAGE: 1,
    PDF: 2,
    MAP: 3
  }

  close () {
    window.close()
  }

  created () {
    switch (this.$route.params.type) {
      case 'img':
        this.type = this.mediaViewerTypes.IMAGE
        this.src = this.$route.query.src
        break
      case 'map':
        this.type = this.mediaViewerTypes.MAP
        this.src = new MarkerPosition(Number(this.$route.query.lat), Number(this.$route.query.lng))
        break
    }
  }
}
